module.exports = __webpack_public_path__ + "static/media/7569ab53-eaed-4693-8da9-c88734daf19b.281d3e79.JPG";